'use strict';
import angular from 'angular';
import _ from 'lodash';

import devicesListHtmlUrl from './views/devices.list.html';

var app = angular.module('devices.component', []);

app.component('devicesList', {
    bindings: {
        showActions: '=',
        selectedData: '=',
        clusterId: '='
    },
    templateUrl: devicesListHtmlUrl,

    // The controller that handles our component logic
    controller: function(ProductService, FormService) {
        var self = this;

        self.deviceSearch = "";
        self.browserSearch = "";
        self.browserLanguageSearch = "";
        self.OSSearch = "";
        self.manufacturerSearch = "";
        self.contentKeys = ['dfp_device_categories', 'dfp_browsers', 'dfp_browser_languages', 'dfp_operating_systems', 'dfp_device_manufacturers'];
        self.deviceCategories = [];
        self.devicesWidget = [];
        self.includeOrExcludeBrowser = null;
        self.includeOrExcludeBL = null;
        self.includeOrExcludeOS = null;
        self.includeOrExcludeDM = null;
        var browserCount = 0;
        var langCount = 0;
        var osCount = 0;
        var dmCount = 0;
        self.browsers = [];
        self.browserLanguages = [];
        self.operatingSystems = [];
        self.deviceManufacturers = [];
        self.catogeriesIncluded = [];
        self.catogeriesExcluded =[];
        self.catogeriesIncludedView = [];
        self.catogeriesExcludedView = [];

        self.changeIncludeExclude = function(item, criteria, data, type) {
            
            self.devicesWidget = data;
            var index = self.devicesWidget.indexOf(item);
            if (index >= 0) {
                if (criteria == "include") {
                    self.devicesWidget[index].criteria = 'include';
                    self.devicesWidget[index].criteria_link = 'included';
                } else if (criteria == "exclude") {
                    self.devicesWidget[index].criteria = 'exclude';
                    self.devicesWidget[index].criteria_link = 'excluded';
                } else {
                    self.devicesWidget[index].criteria = '';
                    self.devicesWidget[index].criteria_link = 'include';
                }
                if(type === 'category') {
                    var selIndex = _.findIndex(self.selectedData.deviceCategories, { id: self.devicesWidget[index].id });
                    if (selIndex >= 0) {
                        self.selectedData.deviceCategories[selIndex] = self.devicesWidget[index];
                    } else {
                        self.selectedData.deviceCategories.push(self.devicesWidget[index]);
                    }
                    self.catogeriesIncluded = _.filter(self.selectedData.deviceCategories, function(item){ return item.criteria == 'include'; }); 
                    self.catogeriesExcluded = _.filter(self.selectedData.deviceCategories, function(item){ return item.criteria == 'exclude'; }); 
                } else if(type === 'browser') {
                    if(browserCount < 1) {
                        self.includeOrExcludeBrowser = criteria + 'browser';
                    }
                    var selIndex = _.findIndex(self.selectedData.browsers, { id: self.devicesWidget[index].id });
                    if (selIndex >= 0) {
                        self.selectedData.browsers[selIndex] = self.devicesWidget[index];
                    } else {
                        self.selectedData.browsers.push(self.devicesWidget[index]);
                    }
                    browserCount++;
                } else if(type === 'browserLanguage') {
                    if(langCount < 1) {
                        self.includeOrExcludeBL = criteria + 'bl';
                    }
                    var selIndex = _.findIndex(self.selectedData.browserLanguages, { id: self.devicesWidget[index].id });
                    if (selIndex >= 0) {
                        self.selectedData.browserLanguages[selIndex] = self.devicesWidget[index];
                    } else {
                        self.selectedData.browserLanguages.push(self.devicesWidget[index]);
                    }
                    langCount++;
                } else if(type === 'deviceManufacture') {
                    if(dmCount < 1) {
                        self.includeOrExcludeDM = criteria + 'dm';
                    }
                    var selIndex = _.findIndex(self.selectedData.deviceManufacturers, { id: self.devicesWidget[index].id });
                    if (selIndex >= 0) {
                        self.selectedData.deviceManufacturers[selIndex] = self.devicesWidget[index];
                    } else {
                        self.selectedData.deviceManufacturers.push(self.devicesWidget[index]);
                    }
                    dmCount++;
                } else {
                    if(osCount < 1) {
                        self.includeOrExcludeOS = criteria + 'os';
                    }
                    var selIndex = _.findIndex(self.selectedData.operatingSystems, { id: self.devicesWidget[index].id });
                    if (selIndex >= 0) {
                        self.selectedData.operatingSystems[selIndex] = self.devicesWidget[index];
                    } else {
                        self.selectedData.operatingSystems.push(self.devicesWidget[index]);
                    }
                    osCount++;
                }           
                
            }
        }

        self.removeDevice = function(item, selectedCategory, devicesData, type) {
            var selIndex = selectedCategory.indexOf(item);
            if (selIndex >= 0) {
                selectedCategory.splice(selIndex, 1);
                if(type == 'category'){
                    var itemIndex;
                    if(item.criteria=='include'){
                         itemIndex = self.catogeriesIncluded.indexOf(item);
                         self.catogeriesIncluded.splice(itemIndex, 1);
                    }
                    else{
                         itemIndex = self.catogeriesExcluded.indexOf(item);
                         self.catogeriesExcluded.splice(itemIndex, 1);
                    }
                }
                if(selIndex === 0 && selectedCategory.length == 0) {
                    if(type === 'os') {
                        osCount = 0;
                        self.includeOrExcludeOS = null;
                    } else if(type === 'lang') {
                        langCount = 0;
                        self.includeOrExcludeBL = null;
                    } else if(type === 'browser') {
                        browserCount = 0;
                        self.includeOrExcludeBrowser = null;
                    } else if(type === 'deviceManufacture') {
                        dmCount = 0;
                        self.includeOrExcludeDM = null;
                    }
                }
            }
            var index = _.findIndex(devicesData, { id: item.id });
            if (index >= 0) {
                devicesData[index].criteria = '';
                devicesData[index].criteria_link = 'include';
            }
        }

        /*
        * get device categories lookup contents
        */
        self.getDevicesByContentKey = function() {
            _.each(self.contentKeys, function(contentKey){
                ProductService.getDevicesByContentKey({clusterId: self.clusterId, contentKey: contentKey}).then(function(success) {
                    if(success && success.lookupContents && success.lookupContents.length > 0) {
                        _.each(success.lookupContents, function(content) {
                            var device = {};
                            device.id = content.id;
                            device.name = content.lookup_value;
                            device.criteria = "";
                            device.criteria_link = "include";
                            if(contentKey === 'dfp_device_categories') {
                                self.deviceCategories.push(device);
                                self.catogeriesIncluded = _.filter(self.selectedData.deviceCategories, function(item){ return item.criteria == 'include'; }); 
                                self.catogeriesExcluded = _.filter(self.selectedData.deviceCategories, function(item){ return item.criteria == 'exclude'; }); 
                            } else if(contentKey === 'dfp_browsers') {
                                self.browsers.push(device);
                            } else if(contentKey === 'dfp_browser_languages') {
                                self.browserLanguages.push(device);
                            } else if(contentKey === 'dfp_operating_systems') {
                                self.operatingSystems.push(device);
                            } else if(contentKey === 'dfp_device_manufacturers') {
                                self.deviceManufacturers.push(device);
                            }
                        })
                        processDevicesData(contentKey);
                    }
                }, function(error) {});
            })
        }

        self.clearSelectedData = function (type, devicesData) {
            if(type=="category"){
               self.selectedData.deviceCategories =[];
               self.includeOrExcludeCategory = null;
               self.catogeriesExcluded =[];
               self.catogeriesIncluded = [];
            }
           else if (type == "browser") {
               self.selectedData.browsers = [];
               browserCount = 0;
               self.includeOrExcludeBrowser = null;
           }
           else if(type=="lang"){
               self.selectedData.browserLanguages =[];
               langCount = 0;
               self.includeOrExcludeBL = null;
           }
           else if(type=="os"){
               self.selectedData.operatingSystems =[];
               osCount = 0;
               self.includeOrExcludeOS = null;
           }
           else if (type == "deviceManufacture") {
               self.selectedData.deviceManufacturers = [];
               dmCount = 0;
               self.includeOrExcludeDM = null;
           }
           _.map(devicesData, function (item) {
               item.criteria = '';
               item.criteria_link = 'include';
           });
       };

        var processDevicesData = function(contentKey) {
            if(self.editMode && self.selectedData) {
                var deviceList = [];
                var subList = [];
                if((self.selectedData.deviceCategories && self.selectedData.deviceCategories.length > 0)
                || (self.selectedData.browsers && self.selectedData.browsers.length > 0) 
                || (self.selectedData.browserLanguages && self.selectedData.browserLanguages.length > 0) 
                || (self.selectedData.operatingSystems && self.selectedData.operatingSystems.length > 0) 
                || (self.selectedData.deviceManufacturers && self.selectedData.deviceManufacturers.length > 0)) {
                    if(contentKey === 'dfp_device_categories') {
                        deviceList = self.deviceCategories;
                        subList = self.selectedData.deviceCategories;
                    } else if(contentKey === 'dfp_browsers') {
                        deviceList = self.browsers;
                        subList = self.selectedData.browsers;
                        self.includeOrExcludeBrowser = subList[0].criteria + 'browser';
                    } else if(contentKey === 'dfp_browser_languages') {
                        deviceList = self.browserLanguages;
                        subList = self.selectedData.browserLanguages;
                        self.includeOrExcludeBL = subList[0].criteria + 'bl';
                    } else if(contentKey === 'dfp_operating_systems') {
                        deviceList = self.operatingSystems;
                        subList = self.selectedData.operatingSystems;
                        self.includeOrExcludeOS = subList[0].criteria + 'os';
                    } else if(contentKey === 'dfp_device_manufacturers') {
                        deviceList = self.deviceManufacturers;
                        subList = self.selectedData.deviceManufacturers;
                        self.includeOrExcludeDM = subList[0].criteria + 'dm';
                    }
                    
                    processCategories(deviceList, subList);
                }
            }
        }

        var processCategories = function(totalList, subList) {
            _.each(totalList, function(category) {
                _.each(subList, function(device) {
                    if(device.id == category.id) {
                        category.criteria = device.criteria;
                        category.criteria_link = device.criteria_link;
                    }
                })
            })
        }
        
        self.initComponent = function() {
            if(self.selectedData && !_.isEmpty(self.selectedData)) {
                if(FormService.isValidJsonString(self.selectedData)){
                    self.selectedData = JSON.parse(self.selectedData);
                }
                if(self.showActions){
                    self.editMode = true;
                    self.enableViewMode = false;
                    self.getDevicesByContentKey();
                }else {
                    self.editMode = false;
                    self.enableViewMode = true;
                    self.catogeriesIncludedView = _.filter(self.selectedData.deviceCategories, function (item) { return item.criteria == 'include'; });
                    self.catogeriesExcludedView = _.filter(self.selectedData.deviceCategories, function (item) { return item.criteria == 'exclude'; });
                }
            } else {
                self.selectedData = {
                    deviceCategories: [],
                    browsers: [],
                    browserLanguages: [],
                    operatingSystems: [],
                    deviceManufacturers: []
                };
                self.enableViewMode = false;
                self.getDevicesByContentKey();
            }
        };

        self.initComponent();
    }
});